import React from "react";
import { useAuth } from "./useAuth";
import { apiClient } from "../utils/apiClient/apiClient";

export const useAuthenticatedApi = () => {
  const { tokens } = useAuth();

  // Set the auth token when tokens change
  React.useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      if (tokens?.accessToken) {
        console.log(
          "Setting auth token:",
          tokens.accessToken.substring(0, 20) + "..."
        );
        // Note: The AWS Amplify client handles auth automatically
        // when using authMode: "userPool" in GraphQL calls
      } else {
        console.log("No auth token available");
      }
    }
  }, [tokens]);

  return apiClient;
};
